import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { CwpNgFrameworkModule } from '@blk/cwp-ng-framework';
import { DzProgressSpinnerModule } from '@blk/daisy/core/loading';
import { AnalyticsModule } from '@ddt-web/analytics';
import { ChartModule } from '@ddt-web/chart';
import { SharedModule } from '@ddt-web/common';
import { DcrModule } from '@ddt-web/dcr';
import { DomModule } from '@ddt-web/dom';
import { GenericDirectivesModule, GenericPipesModule } from '@ddt-web/generic-utils';
import { ApplicationStateStoreProxyService } from '@ddt-web/shared-stores';

import { ChartTableComponent } from './chart-table/chart-table.component';
import { DisplayTableComponent } from './display-table/display-table.component';
import { NestedTableComponent } from './display-table/nested-table/nested-table.component';
import { SimpleFirstColumnTableComponent } from './display-table/simple-first-column-table/simple-first-column-table.component';
import { SimpleTableComponent } from './display-table/simple-table/simple-table.component';
import { NoDataComponent } from './no-data';
import { ProspectusLinksComponent } from './prospectus-links/prospectus-links.component';
import { SectionHeaderComponent } from './section-header';
import { ModelPortfoliosConfigService } from './services/store/model-portfolios-config.service';
import { PortfolioStoreProxyService } from './services/store/portfolio-store-proxy.service';
import { TooltipSectionHeaderComponent } from './tooltip-section-header/tooltip-section-header.component';

@NgModule({
	imports: [
		CommonModule,
		GenericPipesModule,
		GenericDirectivesModule,
		CwpNgFrameworkModule,
		DcrModule,
		SharedModule,
		AnalyticsModule,
		ChartModule,
		DomModule,
		DzProgressSpinnerModule
	],
	declarations: [
		DisplayTableComponent,
		SimpleTableComponent,
		NestedTableComponent,
		ProspectusLinksComponent,
		SimpleFirstColumnTableComponent,
		ChartTableComponent,
		NoDataComponent,
		SectionHeaderComponent,
		TooltipSectionHeaderComponent
	],
	exports: [
		DisplayTableComponent,
		SimpleTableComponent,
		NestedTableComponent,
		ProspectusLinksComponent,
		SimpleFirstColumnTableComponent,
		ChartTableComponent,
		NoDataComponent,
		SectionHeaderComponent,
		TooltipSectionHeaderComponent
	]
})
export class CoreModule {
	public static forRoot(): ModuleWithProviders<CoreModule> {
		return {
			ngModule: CoreModule,
			providers: [
				ModelPortfoliosConfigService,
				PortfolioStoreProxyService,
				ApplicationStateStoreProxyService
			]
		};
	}
}
